<template>
  <RootModalComponent
    :name="$MODAL_NAME.USER_PROFILE"
    icon="ri-user-line"
    :title="'d_ws_profile_modal_title' | translate"
    width="800"
    :mobile-type="$MODAL_TYPE_MOBILE.FULL"
    :footer="modalFooter"
    :frame="true"
    @beforeOpen="beforeOpen"
    @save="onSave"
  >
    <div class="user-modal">
      <form class="user-modal__inner">
        <div class="user-modal__body">
          <div class="row is--mb32">
            <div class="col col-w100 is--role">
              <div class="field">
                <label
                  for="name"
                  class="is--mobile is--required"
                >{{ 'd_ws_user_role' | translate }}*</label>
                <input
                  id="role"
                  type="text"
                  name="name"
                  :value="$store.userRole.name | translate"
                  disabled
                >
              </div>
            </div>
          </div>
          <div class="row is--mb19">
            <div class="col col-w50 is--name">
              <div class="field">
                <label for="name">{{ 'd_ws_user_name' | translate }}*</label>
                <label
                  for="name"
                  class="is--mobile"
                >{{ 'd_ws_user_m_name' | translate }}*</label>
                <input
                  id="name"
                  v-model="name"
                  type="text"
                  name="name"
                  :class="{'is--error': this.errors.name}"
                >
                <div class="error">
                  <span v-if="this.errors.name">
                    {{ this.errorsMessages[this.errors.name] }}
                  </span>
                </div>
              </div>
            </div>
            <div class="col col-w50 is--lastname">
              <div class="field">
                <label for="lastname">{{ 'd_ws_user_surname' | translate }}*</label>
                <input
                  id="lastname"
                  v-model="lastName"
                  type="text"
                  name="lastname"
                  :class="{'is--error': this.errors.lastName}"
                >
                <div class="error">
                  <span v-if="this.errors.lastName">
                    {{ this.errorsMessages[this.errors.lastName] | translate }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col col-w308 is--email">
              <div class="field">
                <label for="email">{{ 'd_ws_user_email' | translate }}*</label>
                <label
                  for="email"
                  class="is--mobile"
                >{{ 'd_ws_user_m_email' | translate }}</label>
                <input
                  id="email"
                  type="email"
                  name="email"
                  :value="$store.user.email"
                  disabled
                >
              </div>
            </div>
            <div class="col col-w148">
              <div class="field">
                <label
                  class="is--secondary"
                >{{ 'd_ws_user_phone' | translate }}</label>
                <phone-mask-input
                  v-model="phone"
                  inputClass="input-phone"
                  wrapperClass="input-phone__wrapper"
                  autoDetectCountry
                />
              </div>
            </div>
          </div>
        </div>
        <div class="user-modal__body is--line-top">
          <div class="row">
            <div class="col col-w50 is--password">
              <div class="field">
                <label for="password">{{ 'd_ws_user_password' | translate }}</label>
                <label
                  for="password"
                  class="is--mobile"
                >{{ 'd_ws_user_m_password' | translate }}</label>
                <div class="password-input">
                  <input
                    id="password"
                    v-model="password"
                    :type="passwordShow ? 'text' : 'password'"
                    name="password"
                    :class="{'is--error': this.errors.password}"
                  >
                  <span
                    class="eye"
                    @click="showPassword(1)"
                  >
                    <i
                      v-if="passwordShow"
                      class="ri-eye-line"
                    />
                    <i
                      v-else
                      class="ri-eye-off-line"
                    />
                  </span>
                </div>
                <div class="error">
                  <span v-if="this.errors.password">
                    {{ this.errorsMessages[this.errors.password] }}
                  </span>
                </div>
              </div>
            </div>
            <div class="col col-w50 is--confirm-password">
              <div class="field">
                <label for="password_confirm">{{ 'd_ws_user_password_repeat' | translate }}</label>
                <div class="password-input">
                  <input
                    id="password_confirm"
                    v-model="confirmPassword"
                    :type="passwordConfirmShow ? 'text' : 'password'"
                    name="password_confirm"
                    :class="{'is--error': this.errors.password}"
                  >
                  <span
                    class="eye"
                    @click="showPassword(2)"
                  >
                    <i
                      v-if="passwordConfirmShow"
                      class="ri-eye-line"
                    />
                    <i
                      v-else
                      class="ri-eye-off-line"
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </RootModalComponent>
</template>

<script>
import RootModalComponent from './RootModalComponent'
import Dropdown from '../controls/Dropdown'

export const FORM_ERROR = Object.freeze({
  EMPTY: 'empty',
  INVALID: 'invalid',
  PASSWORDS_NOT_MATCH: 'passwords_not_match'
});

export default {
  components: {
    RootModalComponent,
    Dropdown
  },
  data() {
    return {
      modalFooter: {
        lineTop: true,
        items: [
          {
            type: 'secondary',
            action: 'cancel',
            title: 'd_ws_button_cancel',
            close: true
          },
          {
            type: 'primary',
            action: 'save',
            title: 'd_ws_button_save',
            close: false
          }
        ]
      },
      name: this.$store.user.name,
      lastName: this.$store.user.surname,
      phone: this.$store.user.phone_number,
      password: '',
      confirmPassword: '',
      errors: {},
      errorsMessages: {
        empty: 'd_ws_profile_modal_error_empty',
        invalid: 'd_ws_profile_modal_error_invalid',
        passwords_not_match: 'd_ws_profile_modal_error_passwords_not_match'
      },
      passwordShow: false,
      passwordConfirmShow: false
    }
  },
  methods: {
    showPassword(type) {
      if (type === 1) this.passwordShow = !this.passwordShow
      else if (type === 2) this.passwordConfirmShow = !this.passwordConfirmShow

    },
    onSave() {
      if (!this.name) {
        this.errors.name = FORM_ERROR.EMPTY
      } else {
        this.errors.name = null
      }

      if (!this.lastName) {
        this.errors.lastName = FORM_ERROR.EMPTY
      } else {
        this.errors.lastName = null
      }

      if (this.password || this.confirmPassword) {
        if (this.password !== this.confirmPassword) {
          this.errors.password = FORM_ERROR.PASSWORDS_NOT_MATCH;
        } else {
          this.errors.password = null;
        }
      } else {
        this.errors.password = null;
      }

      let isOk = true;

      Object.keys(this.errors).forEach(err => {
        if (this.errors[err]) isOk = false
      });

      if (isOk) {

        const params = {
          name: this.name,
          surname: this.lastName,
          phone_number: this.phone
        };

        if (this.password) params.password = this.password;

        this.$crudService.put(`users/self_update`, params).then((resp) => {
          this.$authService.updateUser(this.name, this.lastName, this.phone);
          this.$modal.hide(this.$MODAL_NAME.USER_PROFILE)
        })
      }
    },
    beforeOpen() {
      this.name = this.$store.user.name;
      this.lastName = this.$store.user.surname;
      this.phone = this.$store.user.phone_number;
      this.password = '';
      this.confirmPassword = '';
      this.errors = {
        name: null,
        lastName: null,
        phone: null,
        password: null,
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .user-modal {
    &__body {
      padding: 24px 0 19px 0;
      &.is--line-top {
        padding-top: 32px;
        padding-bottom: 32px;
        border-top: 1px solid var(--grey-04);
      }
      .row {
        max-width: 480px;
        width: 100%;
        margin: 0 auto;
        display: flex;
        &.is--mb32 {
          margin-bottom: 32px;
        }
        &.is--mb19 {
          margin-bottom: 19px;
        }
        .col {
          &-w100 {
            width: 100%;
          }
          &-w50 {
            width: 50%;
            &:first-child {
              padding-right: 12px;
            }
            &:last-child {
              padding-left: 12px;
            }
          }
          &-w308 {
            width: 308px;
          }
          &-w148 {
            width: 148px;
            &:last-child {
              margin-left: auto;
            }
          }
        }
        .field {
          label {
            text-transform: uppercase;
            font-size: 12px;
            font-weight: 600;
            line-height: 130%;
            font-feature-settings: "zeno" on;
            color: var(--label-primary);
            letter-spacing: .5px;
            margin-bottom: 16px;
            display: block;
            &.is--secondary {
              color: var(--label-secondary);
            }
            &.is--mobile {
              display: none;
            }
            &.is--required {
              display: block !important;
            }
          }
          input {
            &.is--error {
              border-color: var(--accent-red);
            }
          }
          .error {
            height: 13px;
            color: var(--accent-red);
            padding-left: 8px;
            font-size: 12px;
            line-height: 13px;
          }
        }
      }
    }
    .password-input {
      position: relative;
      .eye {
        position: absolute;
        top: 0;
        right: 0;
        cursor: pointer;
        height: 100%;
        width: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      input[type="password"] {
        padding-right: 40px;
      }
    }
    .input-phone {
      height: 32px;
      &__wrapper {
        height: auto;
      }
    }
  }

  @media (max-width: 425px) {
    .user-modal {
      &__body {
        padding: 16px 8px;
        .row {
          flex-wrap: wrap;
          .col {
            width: 100%;
            padding-left: 0 !important;
            padding-right: 0 !important;
            &.is--name {
              margin-bottom: 11px;
            }
            &.is--email {
              margin-bottom: 24px;
            }
            .field {
              label {
                display: none;
                &.is--mobile {
                  display: block;
                }
              }
            }
          }
        }
      }
    }
  }
</style>
